import React, { useEffect, useState } from 'react';
import { DOMAIN_SITE_URL } from '../../../shared/constans';
import { EventAfterTipCancel } from './EventAfterTipCancel';
import { useSearchParams } from 'react-router-dom';
import {
  useValidateStripeSessionMutation,
  ValidateStripeSessionResponse,
} from '../../../shared/types/generated';

export const AfterTipCancel: React.FC = () => {
  const [searchParams] = useSearchParams();
  const [alreadyChecked, setAlreadyChecked] = useState(false);
  const [session, setSession] = useState<
    ValidateStripeSessionResponse | undefined | null
  >(undefined);
  const sessionId = searchParams.get('session_id') || '';
  const [callValidate] = useValidateStripeSessionMutation({
    onCompleted: (r) => {
      console.log({ r });
      setSession(r.validateStripeSession);
      setAlreadyChecked(true);
    },
    onError: () => {
      console.log('hubo un error al recuperar la sesion de compra');
      window.location.href = DOMAIN_SITE_URL;
    },
  });
  useEffect(() => {
    if (sessionId) {
      callValidate({
        variables: {
          data: {
            sessionId,
          },
        },
      });
    }
  }, [sessionId, callValidate]);
  if (!sessionId || !alreadyChecked) {
    return null;
  }
  return session ? (
    <EventAfterTipCancel
      ammount={((session?.amount_total || 1) / 100).toFixed(2).toString()}
      session_id={sessionId}
      user={{
        id: 0,
        name: session?.customer_details?.name || '',
        email: session?.customer_details?.email || '',
      }}
    />
  ) : null;
};
